<template>
  <div class="detail-container">
    <p class="title">当前积分</p>
    <h3 class="score">
      {{ score }}
    </h3>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('integral', {
      score: state => state.score
    })
  }
}
</script>
<style lang="scss" scoped>
.detail-container {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 2rem;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  & > .title {
    color: #999;
    font-size: 0.28rem;
  }

  & > .score {
    font-size: 0.68rem;
    margin-top: 0.1rem;
    color: #333;
  }
}
</style>
